
import LogRocket from 'logrocket';
import * as Sentry from '@sentry/react';

export function logError(errorOrMessage, extra, isException = false) {
  try {
    if (window.klaro) {
      const manager = window.klaro.getManager();
      if (manager) {
        const logRocketConsent = manager.getConsent("logrocket");
        const sentryConsent = manager.getConsent("sentry");


          if (isException) {
            // Log to LogRocket as an exception
            if (logRocketConsent) {
              LogRocket.captureException(errorOrMessage, {
                extra,
              });
            }
        
            // Log to Sentry as an exception
            if (sentryConsent) {
              Sentry.captureException(errorOrMessage, {
                extra,
              });
            }
          } else {
            // Log to LogRocket as a message
            if (logRocketConsent) {
                LogRocket.captureMessage(errorOrMessage, {
                  extra,
                });
            }
        
            // Log to Sentry as a message
            if (sentryConsent) {

              Sentry.captureMessage(errorOrMessage, {
                extra,
              });
            }
          }
      }
    }
  } catch (error) {
    console.error("Error checking Klaro consent:", error);
  }
}
